import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Checkbox,
  Input,
  Icon,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardSearchInvoiceGroup = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardSearchInvoiceGroup-div-0"
        style={{width: "100%",height:"100%",padding:"10px"}}>
        <div
          id="CardSearchInvoiceGroup-div-33">
          
          <div
            id="CardSearchInvoiceGroup-div-37"
            style={{display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px 0", margin: "-0.25rem 0 -0.5rem"}}>
            
            <div
              id="CardSearchInvoiceGroup-div-54"
              style={{fontSize: "1.15rem", fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Issue invoices to the parent company" : "ออกใบแจ้งหนี้เรียกเก็บเงินต้นสังกัด"}
            </div>
            <div
              id="CardSearchInvoiceGroup-div-55"
              style={{cursor: "pointer"}}>
              
              <Icon
                className="red large"
                id="CardSearchInvoiceGroup-Icon-56"
                name="close"
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
        </div>
        <div
          className="ui divider"
          id="CardSearchInvoiceGroup-div-34">
          
        </div>
        <div
          className="ui form"
          id="CardSearchInvoiceGroup-div-35">
          
          <FormGroup
            id="CardSearchInvoiceGroup-FormGroup-38"
            inline={true}>
            <FormField
              id="CardSearchInvoiceGroup-FormField-39"
              inline={true}>
              <Checkbox
                checked={props.isCreateDate || false}
                id="CardSearchInvoiceGroup-Checkbox-46"
                label={props.languageUX === "en" ? "Invoice creation date" : "วันที่สร้างใบแจ้งหนี้"}
                name="isCreateDate"
                onClick={props.onChangeValue}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardSearchInvoiceGroup-FormField-40"
              inline={true}>
              <div
                id="CardSearchInvoiceGroup-div-59"
                style={{width: "100%"}}>
                {props.dateTextBox}
              </div>
            </FormField>
            <FormField
              id="CardSearchInvoiceGroup-FormField-41"
              inline={true}>
              <Checkbox
                checked={props.isInvoiceNo || false}
                id="CardSearchInvoiceGroup-Checkbox-48"
                label={props.languageUX === "en" ? "Invoice number" : "เลขที่ใบแจ้งหนี้"}
                name="isInvoiceNo"
                onChange={props.onChangeValue}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardSearchInvoiceGroup-FormField-42"
              inline={true}
              width={2}>
              <Input
                disabled={!props.isInvoiceNo}
                id="CardSearchInvoiceGroup-Input-49"
                name="invoiceNo"
                onChange={props.onChangeValue}
                value={props.invoiceNo || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardSearchInvoiceGroup-FormField-62"
              inline={true}
              style={{ ...(!props.isCoveragePayer && { display: "none" }) }}>
              <Checkbox
                checked={props.isCoverage || false}
                id="CardSearchInvoiceGroup-Checkbox-65"
                label={props.languageUX === "en" ? "Rights" : "สิทธิ"}
                name="isCoverage"
                onChange={props.onChangeValue}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardSearchInvoiceGroup-FormField-63"
              inline={true}
              style={{ ...(!props.isCoveragePayer && { display: "none" }) }}
              width={3}>
              <Dropdown
                clearable={true}
                disabled={!props.isCoverage}
                id="CardSearchInvoiceGroup-Dropdown-66"
                name="coveragePayerSentClaimGroup"
                onChange={props.onChangeValue}
                options={props.coveragePayerOptions}
                search={true}
                selection={true}
                style={{ width: "100%"}}
                value={props.coveragePayerSentClaimGroup}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardSearchInvoiceGroup-FormField-43"
              inline={true}>
              <Checkbox
                checked={props.isFiscalYear || false}
                id="CardSearchInvoiceGroup-Checkbox-50"
                label={props.languageUX === "en" ? "fiscal year" : "ปีงบประมาณ"}
                name="isFiscalYear"
                onChange={props.onChangeValue}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardSearchInvoiceGroup-FormField-44"
              inline={true}
              width={2}>
              <Input
                disabled={!props.isFiscalYear }
                id="CardSearchInvoiceGroup-Input-51"
                name="fiscalYear"
                onChange={props.onChangeValue}
                value={props.fiscalYear || ""}>
              </Input>
            </FormField>
            <div
              style={{ flex: "1" }}>
              
            </div>
            <FormField
              inline={true}>
              <div
                style={{marginLeft: "auto"}}>
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardSearchInvoiceGroup-div-36">
          
          <Table
            data={props.items || []}
            getTrProps={props.getTrProps}
            headers="ปีงบประมาณ,เลขที่ใบแจ้งหนี้,สิทธิ,ประเภทผู้ป่วย,สถานะส่งเบิก"
            id="CardSearchInvoiceGroup-Table-53"
            keys="fiscal_year,lot_no,coverage_code_name,patient_type,sent_claim_status_display"
            minRows={13}
            showPagination={false}
            style={{height: "420px"}}>
          </Table>
        </div>
        <div
          id="CardSearchInvoiceGroup-div-57"
          style={{display: "flex", justifyContent: "flex-end",marginTop: "1rem"}}>
          
          <Button
            color="green"
            disabled={props.disabledButtonSelect || false}
            id="CardSearchInvoiceGroup-Button-58"
            onClick={props.onSelect}>
            {props.languageUX === "en" ? "choose" : "เลือก"}
          </Button>
        </div>
      </div>
    )
}


export default CardSearchInvoiceGroup

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-33"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-34"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-35"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-36"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"5px 0\", margin: \"-0.25rem 0 -0.5rem\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormGroup",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormGroup-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Checkbox",
      "parent": 39,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isCreateDate || false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Checkbox-46"
        },
        "label": {
          "type": "value",
          "value": "วันที่สร้างใบแจ้งหนี้",
          "valueEN": "Invoice creation date"
        },
        "name": {
          "type": "value",
          "value": "isCreateDate"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Checkbox",
      "parent": 41,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isInvoiceNo || false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Checkbox-48"
        },
        "label": {
          "type": "value",
          "value": "เลขที่ใบแจ้งหนี้",
          "valueEN": "Invoice number"
        },
        "name": {
          "type": "value",
          "value": "isInvoiceNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Input",
      "parent": 42,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.isInvoiceNo"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Input-49"
        },
        "name": {
          "type": "value",
          "value": "invoiceNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.invoiceNo || \"\""
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Checkbox",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isFiscalYear || false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Checkbox-50"
        },
        "label": {
          "type": "value",
          "value": "ปีงบประมาณ",
          "valueEN": "fiscal year"
        },
        "name": {
          "type": "value",
          "value": "isFiscalYear"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Input",
      "parent": 44,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.isFiscalYear "
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Input-51"
        },
        "name": {
          "type": "value",
          "value": "fiscalYear"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.fiscalYear || \"\""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 53,
      "name": "Table",
      "parent": 36,
      "props": {
        "data": {
          "type": "code",
          "value": "props.items || []"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "ปีงบประมาณ,เลขที่ใบแจ้งหนี้,สิทธิ,ประเภทผู้ป่วย,สถานะส่งเบิก"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Table-53"
        },
        "keys": {
          "type": "value",
          "value": "fiscal_year,lot_no,coverage_code_name,patient_type,sent_claim_status_display"
        },
        "minRows": {
          "type": "code",
          "value": "13"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"420px\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ออกใบแจ้งหนี้เรียกเก็บเงินต้นสังกัด",
          "valueEN": "Issue invoices to the parent company"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-54"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-55"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Icon",
      "parent": 55,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Icon-56"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-57"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\",marginTop: \"1rem\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Button",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก",
          "valueEN": "choose"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledButtonSelect || false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Button-58"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelect"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-div-59"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-62"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.isCoveragePayer && { display: \"none\" }) }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-FormField-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.isCoveragePayer && { display: \"none\" }) }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Checkbox",
      "parent": 62,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isCoverage || false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Checkbox-65"
        },
        "label": {
          "type": "value",
          "value": "สิทธิ",
          "valueEN": "Rights"
        },
        "name": {
          "type": "value",
          "value": "isCoverage"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Dropdown",
      "parent": 63,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "!props.isCoverage"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchInvoiceGroup-Dropdown-66"
        },
        "name": {
          "type": "value",
          "value": "coveragePayerSentClaimGroup"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.coveragePayerOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.coveragePayerSentClaimGroup"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 38,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"auto\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ flex: \"1\" }"
        }
      },
      "seq": 67,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": true,
  "memo": false,
  "name": "CardSearchInvoiceGroup",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 85
}

*********************************************************************************** */
